import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpSafeHtmlPipe } from './safe-html.pipe';
import { SpByteFormat } from './byte-format.pipe';
import { HtmlToTextPipe } from './html-to-text.pipe';
import { SpTimeFormat } from './time-format.pipe';
import { RemovePTags } from './remove-p-tag.pipe';
import { SpSafeUrlPipe } from './safe-url.pipe';
import { FmFileUrlPipe } from '@sendpulse/file-manager';
import { SpReverseArrayPipe } from '@common/pipes/reverse-array.pipe';

const PIPES = [SpByteFormat, SpTimeFormat, SpReverseArrayPipe];

const STANDALONE_PIPES = [HtmlToTextPipe, FmFileUrlPipe, RemovePTags, SpSafeHtmlPipe, SpSafeUrlPipe];
const MODULES = [CommonModule];

@NgModule({
    imports: [...MODULES, ...STANDALONE_PIPES, ...PIPES],
    exports: [...PIPES, ...STANDALONE_PIPES],
})
export class SpPipesModule {}
